"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createCollectionStore } from "./CYQWQL4J.js";
import { flatten2DArray, reverseArray } from "./7PRQYBBV.js";
import { createStore, setup, sync } from "./BCALMBPZ.js";
import { defaultValue } from "./PBFD2E7P.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/composite/composite-store.ts
var NULL_ITEM = {
  id: null
};
function findFirstEnabledItem(items, excludeId) {
  return items.find(function (item) {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getEnabledItems(items, excludeId) {
  return items.filter(function (item) {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getItemsInRow(items, rowId) {
  return items.filter(function (item) {
    return item.rowId === rowId;
  });
}
function flipItems(items, activeId) {
  var shouldInsertNullItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var index = items.findIndex(function (item) {
    return item.id === activeId;
  });
  return [].concat(_toConsumableArray(items.slice(index + 1)), _toConsumableArray(shouldInsertNullItem ? [NULL_ITEM] : []), _toConsumableArray(items.slice(0, index)));
}
function groupItemsByRows(items) {
  var rows = [];
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    var _loop = function _loop() {
      var item = _step.value;
      var row = rows.find(function (currentRow) {
        var _a;
        return ((_a = currentRow[0]) == null ? void 0 : _a.rowId) === item.rowId;
      });
      if (row) {
        row.push(item);
      } else {
        rows.push([item]);
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return rows;
}
function getMaxRowLength(array) {
  var maxLength = 0;
  var _iterator2 = _createForOfIteratorHelper(array),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var length = _step2.value.length;
      if (length > maxLength) {
        maxLength = length;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return maxLength;
}
function createEmptyItem(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId: rowId
  };
}
function normalizeRows(rows, activeId, focusShift) {
  var maxLength = getMaxRowLength(rows);
  var _iterator3 = _createForOfIteratorHelper(rows),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var row = _step3.value;
      for (var i = 0; i < maxLength; i += 1) {
        var item = row[i];
        if (!item || focusShift && item.disabled) {
          var isFirst = i === 0;
          var previousItem = isFirst && focusShift ? findFirstEnabledItem(row) : row[i - 1];
          row[i] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem(previousItem == null ? void 0 : previousItem.rowId);
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return rows;
}
function verticalizeItems(items) {
  var rows = groupItemsByRows(items);
  var maxLength = getMaxRowLength(rows);
  var verticalized = [];
  for (var i = 0; i < maxLength; i += 1) {
    var _iterator4 = _createForOfIteratorHelper(rows),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var row = _step4.value;
        var item = row[i];
        if (item) {
          verticalized.push(__spreadProps(__spreadValues({}, item), {
            // If there's no rowId, it means that it's not a grid composite, but
            // a single row instead. So, instead of verticalizing it, that is,
            // assigning a different rowId based on the column index, we keep it
            // undefined so they will be part of the same row. This is useful
            // when using up/down on one-dimensional composites.
            rowId: item.rowId ? "".concat(i) : void 0
          }));
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return verticalized;
}
function createCompositeStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  var syncState = (_a = props.store) == null ? void 0 : _a.getState();
  var collection = createCollectionStore(props);
  var activeId = defaultValue(props.activeId, syncState == null ? void 0 : syncState.activeId, props.defaultActiveId);
  var initialState = __spreadProps(__spreadValues({}, collection.getState()), {
    id: defaultValue(props.id, syncState == null ? void 0 : syncState.id, "id-".concat(Math.random().toString(36).slice(2, 8))),
    activeId: activeId,
    baseElement: defaultValue(syncState == null ? void 0 : syncState.baseElement, null),
    includesBaseElement: defaultValue(props.includesBaseElement, syncState == null ? void 0 : syncState.includesBaseElement, activeId === null),
    moves: defaultValue(syncState == null ? void 0 : syncState.moves, 0),
    orientation: defaultValue(props.orientation, syncState == null ? void 0 : syncState.orientation, "both"),
    rtl: defaultValue(props.rtl, syncState == null ? void 0 : syncState.rtl, false),
    virtualFocus: defaultValue(props.virtualFocus, syncState == null ? void 0 : syncState.virtualFocus, false),
    focusLoop: defaultValue(props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, false),
    focusWrap: defaultValue(props.focusWrap, syncState == null ? void 0 : syncState.focusWrap, false),
    focusShift: defaultValue(props.focusShift, syncState == null ? void 0 : syncState.focusShift, false)
  });
  var composite = createStore(initialState, collection, props.store);
  setup(composite, function () {
    return sync(composite, ["renderedItems", "activeId"], function (state) {
      composite.setState("activeId", function (activeId2) {
        var _a2;
        if (activeId2 !== void 0) return activeId2;
        return (_a2 = findFirstEnabledItem(state.renderedItems)) == null ? void 0 : _a2.id;
      });
    });
  });
  var getNextId = function getNextId() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "next";
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _a2, _b;
    var defaultState = composite.getState();
    var _options$skip = options.skip,
      skip = _options$skip === void 0 ? 0 : _options$skip,
      _options$activeId = options.activeId,
      activeId2 = _options$activeId === void 0 ? defaultState.activeId : _options$activeId,
      _options$focusShift = options.focusShift,
      focusShift = _options$focusShift === void 0 ? defaultState.focusShift : _options$focusShift,
      _options$focusLoop = options.focusLoop,
      focusLoop = _options$focusLoop === void 0 ? defaultState.focusLoop : _options$focusLoop,
      _options$focusWrap = options.focusWrap,
      focusWrap = _options$focusWrap === void 0 ? defaultState.focusWrap : _options$focusWrap,
      _options$includesBase = options.includesBaseElement,
      includesBaseElement = _options$includesBase === void 0 ? defaultState.includesBaseElement : _options$includesBase,
      _options$renderedItem = options.renderedItems,
      renderedItems = _options$renderedItem === void 0 ? defaultState.renderedItems : _options$renderedItem,
      _options$rtl = options.rtl,
      rtl = _options$rtl === void 0 ? defaultState.rtl : _options$rtl;
    var isVerticalDirection = direction === "up" || direction === "down";
    var isNextDirection = direction === "next" || direction === "down";
    var canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    var canShift = focusShift && !skip;
    var items = !isVerticalDirection ? renderedItems : flatten2DArray(normalizeRows(groupItemsByRows(renderedItems), activeId2, canShift));
    items = canReverse ? reverseArray(items) : items;
    items = isVerticalDirection ? verticalizeItems(items) : items;
    if (activeId2 == null) {
      return (_a2 = findFirstEnabledItem(items)) == null ? void 0 : _a2.id;
    }
    var activeItem = items.find(function (item) {
      return item.id === activeId2;
    });
    if (!activeItem) {
      return (_b = findFirstEnabledItem(items)) == null ? void 0 : _b.id;
    }
    var isGrid = items.some(function (item) {
      return item.rowId;
    });
    var activeIndex = items.indexOf(activeItem);
    var nextItems = items.slice(activeIndex + 1);
    var nextItemsInRow = getItemsInRow(nextItems, activeItem.rowId);
    if (skip) {
      var nextEnabledItemsInRow = getEnabledItems(nextItemsInRow, activeId2);
      var nextItem2 = nextEnabledItemsInRow.slice(skip)[0] ||
      // If we can't find an item, just return the last one.
      nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1];
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    var canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    var canWrap = isGrid && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    var hasNullItem = isNextDirection ? (!isGrid || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) {
      var loopItems = canWrap && !hasNullItem ? items : getItemsInRow(items, activeItem.rowId);
      var sortedItems = flipItems(loopItems, activeId2, hasNullItem);
      var _nextItem = findFirstEnabledItem(sortedItems, activeId2);
      return _nextItem == null ? void 0 : _nextItem.id;
    }
    if (canWrap) {
      var _nextItem2 = findFirstEnabledItem(
      // We can use nextItems, which contains all the next items, including
      // items from other rows, to wrap between rows. However, if there is a
      // null item (the composite container), we'll only use the next items in
      // the row. So moving next from the last item will focus on the
      // composite container. On grid composites, horizontal navigation never
      // focuses on the composite container, only vertical.
      hasNullItem ? nextItemsInRow : nextItems, activeId2);
      var nextId = hasNullItem ? (_nextItem2 == null ? void 0 : _nextItem2.id) || null : _nextItem2 == null ? void 0 : _nextItem2.id;
      return nextId;
    }
    var nextItem = findFirstEnabledItem(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) {
      return null;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
  return __spreadProps(__spreadValues(__spreadValues({}, collection), composite), {
    setBaseElement: function setBaseElement(element) {
      return composite.setState("baseElement", element);
    },
    setActiveId: function setActiveId(id) {
      return composite.setState("activeId", id);
    },
    move: function move(id) {
      if (id === void 0) return;
      composite.setState("activeId", id);
      composite.setState("moves", function (moves) {
        return moves + 1;
      });
    },
    first: function first() {
      var _a2;
      return (_a2 = findFirstEnabledItem(composite.getState().renderedItems)) == null ? void 0 : _a2.id;
    },
    last: function last() {
      var _a2;
      return (_a2 = findFirstEnabledItem(reverseArray(composite.getState().renderedItems))) == null ? void 0 : _a2.id;
    },
    next: function next(options) {
      if (options !== void 0 && typeof options === "number") {
        options = {
          skip: options
        };
      }
      return getNextId("next", options);
    },
    previous: function previous(options) {
      if (options !== void 0 && typeof options === "number") {
        options = {
          skip: options
        };
      }
      return getNextId("previous", options);
    },
    down: function down(options) {
      if (options !== void 0 && typeof options === "number") {
        options = {
          skip: options
        };
      }
      return getNextId("down", options);
    },
    up: function up(options) {
      if (options !== void 0 && typeof options === "number") {
        options = {
          skip: options
        };
      }
      return getNextId("up", options);
    }
  });
}
export { createCompositeStore };